export const officePath = '/products';
export const officePagePath = officePath + '/:productTypeSlug?';